var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"min-h-[400px] desktop:min-h-none",attrs:{"src":_setup.props.externallink,"width":"100%","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }